import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pde-reports")({
  head: () => buildRouteHead("/pde-reports", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/toxicology/pde-oel-reports", replace: true });
  },
});
